import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { Separator, LayoutBand, List, ListItem, Image, H3, H5, Paragraph, colors } from '@fs/zion-ui'
import { PlaceTemple, ContentCheck, Person } from '@fs/zion-icon'
import GatherIsraelPNG from '../../assets/img/president-nelson-youth-gather-israel.png'
import BitmovinPlayer from '../../video/eden-bitmovin-player/src/index'
import { brightcoveConfig } from '../../video/configs'
import { cdnRoot } from '../../services/services'

export default function YourAncestorsNeedYou() {
  const [t] = useTranslation()

  const pageStyles = css`
    [data-text-color-alert] {
      color: ${colors.red60};
    }
  `
  return (
    <LayoutBand maxWidth="xs" css={pageStyles}>
      <Separator />
      <Image
        alt={t(
          'informational.temple.prepare.youth.ancestor.image-alt',
          'A young woman prepares names for the temple with her mother.'
        )}
        src={`${cdnRoot}/connect/informational/youth-temple-prep-name.png`}
      />
      <Separator />

      <H3>{t('informational.temple.prepare.youth.ancestor.heading', 'Your Ancestors Need You')}</H3>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph1',
          "As part of preparing for temple baptisms, you can help your child catch the vision of why we serve in the temple. Plus, as you'll see below, it's easier than ever to help him or her find an ancestor who needs your help in the temple. And if you don't live close to a temple or your child's first temple visit isn't happening soon, engaging in family history is still important and will bring great blessings."
        )}
      </Paragraph>
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph2',
          "Serving in the Temple is Gathering Israel By providing the essential covenants and ordinances of the gospel to our ancestors and others we help ensure that all of God's children are offered the chance to return to His presence."
        )}
      </Paragraph>
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph3',
          'President Nelson recently taught these powerful truths to the youth of the Church: “You were sent to earth at this precise time, the most crucial time in the history of the world, to help gather Israel,” he said. “There is nothing happening on this earth right now that is more important than that . . .Absolutely nothing” (“Hope of Israel,” Worldwide Youth Devotional, June 3, 2018).'
        )}
      </Paragraph>
      <Separator />
      <BitmovinPlayer
        thumbnail={GatherIsraelPNG}
        videoData={{ videoId: '5850093869001', accountId: brightcoveConfig.master.accountId }}
      />
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph4',
          'President Nelson also explained what it means to gather Israel: “Anytime you do anything that helps anyone —on either side of the veil —take a step toward making covenants with God and receiving their essential baptismal and temple ordinances, you are helping to gather Israel. It is as simple as that.”'
        )}
      </Paragraph>
      <Separator />
      <H5>{t('informational.temple.prepare.youth.ancestor.find', 'An Easy Way to Find an Ancestor')}</H5>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph5',
          "The Family Tree app and the FamilySearch.org website have a tool called Ordinances Ready that can help you discover your ancestors—and others—who are in need of gospel ordinances. As you teach your children how to use Ordinances Ready, you will be showing them one way they can follow the prophet's call to help gather Israel and invite all to follow our Savior."
        )}
      </Paragraph>
      <Separator />
      <H5 data-text-color-alert>
        {t(
          'informational.temple.prepare.youth.ancestor.activity-prompt',
          'ACTIVITY: Help your child use Ordinances Ready to find a name'
        )}
      </H5>
      <Separator />
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph6',
          'First, have your child sign in to the Family Tree app using his or her own FamilySearch log-in information.'
        )}
      </Paragraph>
      <List>
        <ListItem
          primaryText={t('informational.temple.prepare.youth.ancestor.tap-temple', 'Tap the Temple icon.')}
          startElement={<ListItem.Icon Icon={PlaceTemple} />}
        />
        <ListItem
          primaryText={t('informational.temple.prepare.youth.ancestor.tap-ready', 'Tap Ordinances Ready.')}
          startElement={<ListItem.Icon Icon={ContentCheck} />}
        />
        <ListItem
          primaryText={t(
            'informational.temple.prepare.youth.ancestor.tap-baptism-confirmation',
            'Tap Baptism and Confirmation'
          )}
          startElement={<ListItem.Icon Icon={Person} />}
        />
      </List>
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph7',
          "The app will search your son's or daughter's family tree for ancestors who need these ordinances. You may then reserve the ordinances for your next trip to the temple. If there are no ordinances for your own family, the system will provide names of ancestors of fellow Church members who need your help in performing ordinances for their ancestors. Your participation in this work is valuable, no matter who you are serving in the temple, and it's all a part of gathering Israel."
        )}
      </Paragraph>
      <Paragraph>
        {t(
          'informational.temple.prepare.youth.ancestor.paragraph8',
          "Get to know your ancestors: After you have reserved the ordinances, you can visit each ancestor's profile page in Family Tree and learn a little bit about him or her. Review any stories or photos that have been saved, and be sure to select View My Relationship. That way you'll know exactly how you're related to this ancestor."
        )}
      </Paragraph>
      <Separator />
    </LayoutBand>
  )
}
